import type {
  ItBiweeklyReportData,
  ItBiweeklyReportParams,
} from './types/it-biweekly-report'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'

import { buildItBiweeklyReportParams } from './it-biweekly-report-params'

export const itBiweeklyReportApi = defineApi('operation', ({ prefix }) => {
  /**
   * 查询 IT 双周会报表汇总数据
   * POST /gobestads/operation/itBiweeklyReport/summary
   */
  function getItBiweeklyReport(
    params?: ItBiweeklyReportParams,
  ): Promise<ItBiweeklyReportData | null> {
    return requestClient
      .post<ItBiweeklyReportData | null>(
        prefix('itBiweeklyReport/summary'),
        buildItBiweeklyReportParams(params?.statDate),
      )
      .then((response) => response)
  }

  return { getItBiweeklyReport }
})
